import React from 'react';

type WhenProps = {
  children: React.ReactNode | React.ReactNode[] | React.ReactElement | React.ReactElement[];
  isTrue?: boolean;
};

const RenderWhen = ({ isTrue, children }: WhenProps) => {
  const list: React.ReactNode[] = [];

  if (isTrue !== true) {
    return null;
  }

  React.Children.map(children, (child: any) => {
    const { isTrue: isChildTrue } = child?.props || {};

    if (isChildTrue === true) {
      list.push(child);
    }
  });

  return <>{list}</>;
};

RenderWhen.defaultProps = {
  isTrue: true
};

RenderWhen.If = ({ children, isTrue }) => children;

export default RenderWhen;
